module.exports = __webpack_public_path__ + "img/8select-3.6afe37b0.jpg";